'use strict';

module.exports = ['$scope', '$modalInstance', 'config', '$http', 'PlantSvc', 'MembershipSvc', function ($scope, $modalInstance, config, $http, PlantSvc, MembershipSvc) {
    // ------------------
    // Scope
    // ------------------
    $scope.ok = function () {
        var formData = {
            email: $scope.newUser.email,
            name: $scope.newUser.name,
            plant: $scope.newUser.plant,
            role: $scope.newUser.role
        };

        $scope.disableInput = true;

        $http.post('/account/invite_to/', formData).success(function (data) {
            $modalInstance.close(data);
            $scope.disableInput = false;
        }).error(function (data) {
            $scope.error = data;
            $scope.disableInput = false;
        });
    };

    $scope.cancel = function () {
        $modalInstance.dismiss();
    };


    // ------------------
    // Helpers
    // ------------------
    function getRoles(plantId) {
        MembershipSvc.list_roles(plantId).then(function (membershipsResult) {
            $scope.roles = membershipsResult.data;
            if ($scope.roleName) {
                $scope.newUser.role = Array.findObject($scope.roles, "name", $scope.roleName).id;
            }
        });
    }

    // ------------------
    // Initialization
    // ------------------

    function init() {
        $scope.organization = config.organization;
        $scope.plant = config.plant;
        $scope.showWarning = config.showWarning;
        $scope.roleName = config.roleName;

        $scope.title = config.title || "Add Employee";

        $scope.disableInput = false;

        $scope.newUser = {
            name: '',
            email: ''
        };

        // ------------------------
        //  Load Dependent Data
        // ------------------------
        if (config.plant) {
            $scope.newUser.plant = config.plant.id;
            getRoles(config.plant.id);
        } else {
            PlantSvc.list({
                organization: $scope.organization.id
            }).then(function (plantsResult) {
                $scope.plants = plantsResult.data;
                if ($scope.plants.length > 0) {
                    getRoles($scope.plants[0].id);
                } else {
                    $scope.disableInput = true;
                    $scope.errorMessage = {
                        content: "There are no active plant's in this business."
                    };
                }
            });
        }
    }

    init();

}];